import React, { useState, useEffect, useRef } from 'react';
import { ClientService } from "../service/ClientService";
import { ProfileService } from "../service/ProfileService";
import { LanguageService } from "../service/LanguageService";
import classNames from 'classnames';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { AuthorizationService, MANAGE_CONFIGURATION } from '../service/AuthorizationService';
import './Crud.scss'
import * as _ from 'lodash';
import { ProgressBar } from 'primereact/progressbar';
import { v4 as uuidv4 } from 'uuid';
import {Chips} from 'primereact/chips';
import { Paginator } from 'primereact/paginator';
import { Fieldset } from 'primereact/fieldset';
import { ToggleButton } from 'primereact/togglebutton';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { Panel } from 'primereact/panel';
import {Password} from 'primereact/password';
import { ContaAzulConfiguration } from './contaazul/ContaAzulConfiguration';
import { ContaAzulService } from '../service/ContaAzulService';

export function ConfigCrud(props) {

    const [client, setClient] = useState(null);
    const [hasAccess, setHasAccess] = useState(false);
    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(true);
    const [submitted, setSubmitted] = useState(false);
    const toast = useRef(null);
    const dt = useRef(null);
    const clientService = new ClientService();
    const authorizationService = new AuthorizationService();
    const languageService = new LanguageService();

    const [openContaAzulConfig, setOpenContaAzulConfig] = useState(false);

    useEffect(() => {
        setHasAccess(authorizationService.hasPermission(MANAGE_CONFIGURATION));
        setOpenContaAzulConfig((localStorage.getItem("ca_return") || "") !== "");

        if(authorizationService.hasPermission(MANAGE_CONFIGURATION)){
            async function fetchData() {
                const _client = await clientService.get(props.client);
                setClient(_client);
                setLoading(false);
            }        
            fetchData();            
           
        }
    }, []);

    const saveDisabled = () => {
        return (client.name || "") === ""
            || (client.shortcode || "") === ""
            || (client.logo || "") === ""
            || (client.powerbi_username || "") === ""
            || (client.powerbi_password || "") === ""
            || (client.powerbi_appid || "") === ""
            || (client.powerbi_secret || "") === "";
    }

    const save = async () => {
        try {
            setSaving(true);
            await clientService.update(client);
            toast.current.show({ severity: 'success', summary: languageService.getText('Successful'), detail: languageService.getText('ConfigurationsSaved'), life: 3000 });
            setSaving(false);
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.toString(), sticky: true });
            setSaving(false);
            console.log(error);
            throw error;
        }
    }

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _client = { ...client };
        _.set(_client, name, val);
        setClient(_client);
    }

    const onValueChange = (val, name) => {
        console.log(val, name)
        let _client = { ...client };
        _.set(_client, name, val);
        setClient(_client);
    }

    const righToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label={languageService.getText("Save")} icon="pi pi-check" className="p-button-success p-mr-2" onClick={save} />
            </React.Fragment>
        );
    }

    const closeContaAzulConfig = () => {
        setOpenContaAzulConfig(false);
    }

    const [searchingCAAaccounts, setSearchingCAAaccounts] = useState(false);
    const [editingCAAaccounts, setEditingCAAaccounts] = useState(false);
    const [cAAaccounts, setCAAaccounts] = useState([]);
    const listContaAzulAccounts = async () => {
        setEditingCAAaccounts(true);
        setSearchingCAAaccounts(true);
        const service = new ContaAzulService();
        setCAAaccounts(await service.listAccount());
        setSearchingCAAaccounts(false);
    }

    if(hasAccess){

        return (
            <div className="datatable-crud-demo">
                <Toast ref={toast} />
                <div className="card">
                    { loading && <ProgressBar mode="indeterminate"/> }
                    { !loading && <Toolbar className="p-mb-4" right={righToolbarTemplate}></Toolbar>}                
                

                    { client && <>
                        <Panel header={languageService.getText("Identity")} style={{marginBottom: '5px'}}>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-3">
                                <b>{languageService.getText("ID")}:</b>&nbsp;{client.bizid}
                            </div>
                            <div className="p-field p-col-9">
                            <b>{languageService.getText("Name")}:</b>&nbsp;{client.name}
                            </div>
                        </div>
                        </Panel>

                        { client.signup_config.allowed && client.signup_config.acceptTermsEnabled && <>
                            <Fieldset legend={"Auto Inscrição"} toggleable style={{marginBottom: '5px'}}>
                                <div className="p-formgrid p-grid">
                                    <div className="p-field p-col-12 p-lg-12">
                                        <label htmlFor="description">URL do PDF de Termos de Uso</label>
                                    </div>
                                    <div className="p-field p-col-12 p-lg-12">
                                        <InputText disabled={saving} id="termosdeuso" value={client.signup_config.termsURL} onChange={(e) => onInputChange(e, 'signup_config.termsURL')} required autoFocus className={classNames({ 'p-invalid': submitted && !client.signup_config.termsURL })} style={{width: '100%'}}/>
                                        {submitted && !client.signup_config.termsURL && <small className="p-invalid">URL PDF Termos de Uso {languageService.getText("is_required")}.</small>}
                                    </div>
                                </div>
                            </Fieldset>
                            </>
                        }
                    
                        <Fieldset legend={"Customizações de Layout"} toggleable style={{marginBottom: '5px'}}>
                            <div className="p-formgrid p-grid">
                                <div className="p-field p-col-12 p-lg-6">
                                    <label htmlFor="description">URL Logo*</label>
                                </div>
                                <div className="p-field p-col-12 p-lg-6">
                                    <label htmlFor="description">URL FavIcon*</label>
                                </div>
                                
                                <div className="p-field p-col-12 p-lg-6">
                                    <InputText disabled={saving} id="logo" value={client.logo} onChange={(e) => onInputChange(e, 'logo')} required autoFocus className={classNames({ 'p-invalid': submitted && !client.logo })}  style={{width: '100%'}}/>
                                    {submitted && !client.logo && <small className="p-invalid">Logo URL {languageService.getText("is_required")}.</small>}
                                </div>
                                
                                <div className="p-field p-col-12 p-lg-6">
                                    <InputText disabled={saving} id="logo" value={client.custom_layout.favicon || ''} onChange={(e) => onInputChange(e, 'custom_layout.favicon')} required autoFocus  style={{width: '100%'}}/>                                
                                </div>

                                <div className="p-field p-col-12 p-lg-6">
                                    <label htmlFor="description">URL Landing Page Customizada</label>
                                </div>
                                <div className="p-field p-col-12 p-lg-6">&nbsp;</div>

                                <div className="p-field p-col-12 p-lg-6">
                                <InputText disabled={saving} id="logo" value={(client.config.custom_initial_page || {}).url || ''} onChange={(e) => onInputChange(e, 'config.custom_initial_page.url')} required autoFocus  style={{width: '100%'}}/>  
                                </div>
                                <div className="p-field p-col-12 p-lg-6">&nbsp;</div>


                            <div className="p-field p-col-12 p-lg-3">
                                <label htmlFor="primaryBackgroundColor">Cor de Fundo Primária</label><br/>
                                <InputText disabled={saving} id="primaryBackgroundColor" value={client.custom_layout.primaryBackgroundColor || ''} onChange={(e) => onInputChange(e, 'custom_layout.primaryBackgroundColor')} required autoFocus style={{backgroundColor: client.custom_layout.primaryBackgroundColor}} />    
                            </div>
                            <div className="p-field p-col-12 p-lg-3">
                                <label htmlFor="secondaryBackgroundColor">Cor de Fundo Secundária</label><br/>
                                <InputText disabled={saving} id="secondaryBackgroundColor" value={client.custom_layout.secondaryBackgroundColor || ''} onChange={(e) => onInputChange(e, 'custom_layout.secondaryBackgroundColor')} required autoFocus style={{backgroundColor: client.custom_layout.secondaryBackgroundColor}} />    
                            </div>
                            <div className="p-field p-col-12 p-lg-3">
                                <label htmlFor="primaryButtonColor">Cor do Botão</label><br/>
                                <InputText disabled={saving} id="primaryButtonColor" value={client.custom_layout.primaryButtonColor || ''} onChange={(e) => onInputChange(e, 'custom_layout.primaryButtonColor')} required autoFocus style={{backgroundColor: client.custom_layout.primaryButtonColor}} />    
                            </div>
                            <div className="p-field p-col-12 p-lg-3">
                                <label htmlFor="primaryFontColor">Cor da Fonte</label><br/>
                                <InputText disabled={saving} id="primaryFontColor" value={client.custom_layout.primaryFontColor || ''} onChange={(e) => onInputChange(e, 'custom_layout.primaryFontColor')} required autoFocus style={{backgroundColor: client.custom_layout.primaryFontColor}} />    
                            </div>
                        </div>
                    </Fieldset> 

                    <Fieldset legend={"Configuração de Envio de E-mail"} toggleable style={{marginBottom: '5px'}}>
                        <div className="p-formgrid p-grid">
                            <div className="p-field p-col-12 p-lg-6">
                                <label htmlFor="description">URL*</label>
                            </div>
                            <div className="p-field p-col-12 p-lg-6">
                                <label htmlFor="description">Porta*</label>
                            </div>
                            <div className="p-field p-col-12 p-lg-6">
                                <InputText disabled={saving} id="smtp_url" value={client.email_config.smtp.url} onChange={(e) => onInputChange(e, 'email_config.smtp.url')}  style={{width: '100%'}} />
                            </div>
                            <div className="p-field p-col-12 p-lg-6">
                                <InputText disabled={saving} id="smtp_port" value={client.email_config.smtp.port} onChange={(e) => onInputChange(e, 'email_config.smtp.port')}  style={{width: '100%'}} />
                            </div>
                            <div className="p-field p-col-12 p-lg-6">
                                <label htmlFor="description">Login*</label>
                            </div>
                            <div className="p-field p-col-12 p-lg-6">
                                <label htmlFor="description">Senha*</label>
                            </div>
                            <div className="p-field p-col-12 p-lg-6">
                                <InputText disabled={saving} id="smtp_user" value={client.email_config.smtp.user} onChange={(e) => onInputChange(e, 'email_config.smtp.user')}  style={{width: '100%'}} />
                            </div>
                            <div className="p-field p-col-12 p-lg-6">
                                <Password feedback={false} toggleMask={true} disabled={saving} id="smtp_password" value={client.email_config.smtp.password} onChange={(e) => onInputChange(e, 'email_config.smtp.password')}  inputStyle={{width: '100%'}} />
                            </div>
                        </div>
                    </Fieldset> 

                    <Fieldset legend={"Configuração de Mensagens"} toggleable style={{marginBottom: '5px'}}>
                        <div className="p-formgrid p-grid">
                            <div className="p-field p-col-12 p-lg-12">
                                <label htmlFor="description"><b>First Password Set Message</b></label>
                            </div>
                            <div className="p-field p-col-12 p-lg-12">
                                <label htmlFor="passwordSet_from">From*</label>
                            </div>
                            <div className="p-field p-col-12 p-lg-12">
                                <InputText disabled={saving} id="passwordSet_from" value={client.email_config.fromAddress} onChange={(e) => onInputChange(e, 'email_config.fromAddress')}  style={{width: '100%'}}/>
                            </div>
                            <div className="p-field p-col-12 p-lg-12">
                                <label htmlFor="passwordSet_subject">Subject*</label>
                            </div>
                            <div className="p-field p-col-12 p-lg-12">
                                <InputText disabled={saving} id="passwordSet_subject" value={client.email_config.passwordSet.subject} onChange={(e) => onInputChange(e, 'email_config.passwordSet.subject')}  style={{width: '100%'}}/>
                            </div>
                            <div className="p-field p-col-12 p-lg-12">
                                <label htmlFor="passwordSet_html">HTML*</label>
                            </div>
                            <div className="p-field p-col-12 p-lg-12">
                                <InputTextarea disabled={saving} id="passwordSet_html" value={client.email_config.passwordSet.html} onChange={(e) => onInputChange(e, 'email_config.passwordSet.html')}  style={{width: '100%'}}/>
                            </div>
                        </div>
                    </Fieldset> 
                    { ((client.modules || []).filter(m => m.id === "REPORTS").length > 0) && <>
                    <Fieldset legend={"Configuração do Power BI"} toggleable style={{marginBottom: '5px'}}>
                        <div className="p-formgrid p-grid">
                            <div className="p-field p-col-6 p-lg-6">
                                <label htmlFor="clientId">Username*</label>
                            </div>
                            <div className="p-field p-col-6 p-lg-6">
                                <label htmlFor="groupId">Password*</label>
                            </div>
                            <div className="p-field p-col-6 p-lg-6">
                                <InputText disabled={saving} id="clientId" value={client.powerbi_username} onChange={(e) => onInputChange(e, 'powerbi_username')} required className={classNames({ 'p-invalid': submitted && !client.powerbi_username })}  style={{width: '100%'}} />
                                {submitted && !client.powerbi_username && <small className="p-invalid">Username {languageService.getText("is_required")}.</small>}
                            </div>                            
                            <div className="p-field p-col-6 p-lg-6">
                                <Password feedback={false} toggleMask={true} disabled={saving} id="groupId" value={client.powerbi_password} onChange={(e) => onInputChange(e, 'powerbi_password')} required className={classNames({ 'p-invalid': submitted && !client.powerbi_password })}  inputStyle={{width: '100%'}} />
                                {submitted && !client.powerbi_password && <small className="p-invalid">Password {languageService.getText("is_required")}.</small>}
                            </div>
                        </div>
                        <div className="p-formgrid p-grid">
                            <div className="p-field p-col-4 p-lg-4">
                                <label htmlFor="powerbi_appid">App ID*</label>
                            </div>
                            <div className="p-field p-col-4 p-lg-4">
                                <label htmlFor="powerbi_secret">Secret*</label>
                            </div>
                            <div className="p-field p-col-4 p-lg-4">
                                <label htmlFor="powerbi_capacity">Capacity ID</label>
                            </div>
                            <div className="p-field p-col-4 p-lg-4">
                                <Password feedback={false} toggleMask={true} disabled={saving} id="powerbi_appid" value={client.powerbi_appid} onChange={(e) => onInputChange(e, 'powerbi_appid')} required className={classNames({ 'p-invalid': submitted && !client.powerbi_appid })}  inputStyle={{width: '100%'}} />
                                {submitted && !client.powerbi_appid && <small className="p-invalid">App ID {languageService.getText("is_required")}.</small>}
                            </div>
                            <div className="p-field p-col-4 p-lg-4">
                                <Password feedback={false} toggleMask={true} disabled={saving} id="powerbi_secret" value={client.powerbi_secret} onChange={(e) => onInputChange(e, 'powerbi_secret')} required className={classNames({ 'p-invalid': submitted && !client.powerbi_secret })}  inputStyle={{width: '100%'}} />
                                {submitted && !client.powerbi_secret && <small className="p-invalid">Secret {languageService.getText("is_required")}.</small>}
                            </div>
                            <div className="p-field p-col-4 p-lg-4">
                                <InputText disabled={saving} id="powerbi_capacity" value={client.powerbi_config.capacity} onChange={(e) => onInputChange(e, 'powerbi_config.capacity')} style={{width: '100%'}} />
                            </div>
                        </div>
                    </Fieldset>
                    </>}
                    { ((client.modules || []).filter(m => m.id === "SUBSCRIPTION_PLANS").length > 0) &&
                    <Fieldset legend={"Configuração dos Planos de Assinatura"} toggleable style={{marginBottom: '5px'}}>
                        <div className="p-field p-col-6 p-lg-6">
                            <label htmlFor="primaryFontColor"><b>Ativo</b></label>: <ToggleButton onLabel="Sim" offLabel="Não" onIcon="pi pi-check" offIcon="pi pi-times" checked={client.config.signature_plans_enabled ? true : false} onChange={(e) => onValueChange(e.value, 'config.signature_plans_enabled')} />
                        </div>
                        <div className="p-field p-col-6 p-lg-6">
                            <label htmlFor="primaryFontColor"><b>Vitrine de Plano na Home</b></label>: <ToggleButton onLabel="Sim" offLabel="Não" onIcon="pi pi-check" offIcon="pi pi-times" checked={client.config.signature_plans_home_enabled ? true : false} onChange={(e) => onValueChange(e.value, 'config.signature_plans_home_enabled')} />
                        </div>
                        <div className="p-field p-col-12 p-lg-12">
                            <Fieldset legend={"Meios de Pagamento"} toggleable style={{marginBottom: '5px'}}>
                                <div className="p-field p-col-12 p-lg-12">
                                    <label htmlFor="primaryFontColor"><b>Boleto (Manual via Backoffice)</b></label>: <ToggleButton onLabel="Sim" offLabel="Não" onIcon="pi pi-check" offIcon="pi pi-times" checked={(client.config.payment_methods || {}).offline ? true : false} onChange={(e) => onValueChange(e.value, 'config.payment_methods.offline')} />
                                </div>
                                <div className="p-field p-col-12 p-lg-12">
                                    <label htmlFor="primaryFontColor"><b>Cartão de Credito</b></label>: <ToggleButton onLabel="Sim" offLabel="Não" onIcon="pi pi-check" offIcon="pi pi-times" checked={(client.config.payment_methods || {}).credit_card ? true : false} onChange={(e) => onValueChange(e.value, 'config.payment_methods.credit_card')} />
                                </div>
                            </Fieldset>
                        </div>
                        <div className="p-field p-col-12 p-lg-12">
                            <Fieldset legend={"Integração Conta Azul"} toggleable style={{marginBottom: '5px'}}>
                                <div className="p-field p-col-12 p-lg-12">
                                    <label htmlFor="primaryFontColor"><b>Ativo</b></label>: <ToggleButton onLabel="Sim" offLabel="Não" onIcon="pi pi-check" offIcon="pi pi-times" checked={client.config.contaazul_integration_enabled ? true : false} onChange={(e) => onValueChange(e.value, 'config.contaazul_integration_enabled')} />
                                </div>
                                { client.config.contaazul_integration_enabled && 
                                        <>
                                <div className="p-field p-col-12 p-lg-12">
                                    <label htmlFor="primaryFontColor"><b>Configuração</b></label>: 
                                   
                                            
                                            <Button label={languageService.getText("Configurar")} icon="pi pi-cog" className="p-button-success p-mr-2" onClick={() => setOpenContaAzulConfig(true)} />
                                            <ContaAzulConfiguration
                                                    visible={openContaAzulConfig}
                                                    tenant={client} 
                                                    onConfigEnded={() => setOpenContaAzulConfig(false)}
                                            />
                                   
                                </div>
                                <div className="p-field p-col-12 p-lg-12" style={{ display: 'flex'}}>
                                    <label htmlFor="primaryFontColor"><b>Conta</b></label>:&nbsp;
                                    { !editingCAAaccounts && <>
                                        { client.config.contaazul_account ? client.config.contaazul_account.name : "" }
                                        &nbsp;&nbsp;<Button label={languageService.getText("Selecionar")} icon="pi pi-pencil" className="p-button-success p-mr-2" onClick={() => listContaAzulAccounts()} />
                                    </>}
                                    { editingCAAaccounts && <>
                                        { searchingCAAaccounts && <ProgressSpinner style={{width: '50px', height: '50px'}}/>}
                                        { !searchingCAAaccounts && 
                                            <div>
                                            &nbsp;&nbsp;<Dropdown value={(client.config.contaazul_account || {}).uuid} options={cAAaccounts} optionLabel="name" optionValue='uuid' onChange={(e) => onValueChange(cAAaccounts.find(a => a.uuid === e.value), 'config.contaazul_account')}/>
                                            &nbsp;&nbsp;<Button label={languageService.getText("OK")} icon="pi pi-check" className="p-button-success p-mr-2" onClick={() => setEditingCAAaccounts(false)} />
                                            </div>
                                        
                                        }
                                    </>}
                                    
                                </div>
                                </>
                                    }
                            </Fieldset>
                        </div>
                        <div className="p-field p-col-12 p-lg-12">
                            <Fieldset legend={"Integração Mercado Pago"} toggleable style={{marginBottom: '5px'}}>
                                <div className="p-field p-col-12 p-lg-12">
                                    <label htmlFor="primaryFontColor"><b>Ativo</b></label>:&nbsp;&nbsp;
                                    <ToggleButton onLabel="Sim" offLabel="Não" onIcon="pi pi-check" offIcon="pi pi-times" checked={client.config.mercadopago_integration_enabled ? true : false} onChange={(e) => onValueChange(e.value, 'config.mercadopago_integration_enabled')} />
                                </div>
                                { client.config.mercadopago_integration_enabled && 
                                    <>
                                        <div className="p-field p-col-12 p-lg-12">
                                            <label htmlFor="tracking_id"><b>Public Key</b></label>
                                        </div>
                                        <div className="p-field p-col-12 p-lg-12">
                                            <InputText disabled={saving} id="mercadopago_public_key" value={client.config.mercadopago_public_key} onChange={(e) => onInputChange(e, 'config.mercadopago_public_key')}  style={{width: '100%'}}/>
                                        </div>
                                        <div className="p-field p-col-12 p-lg-12">
                                            <label htmlFor="tracking_id"><b>Access Token</b></label>
                                        </div>
                                        <div className="p-field p-col-12 p-lg-12">
                                            <Password feedback={false} toggleMask={true} disabled={saving} id="mercadopago_access_token" value={client.config.mercadopago_access_token} onChange={(e) => onInputChange(e, 'config.mercadopago_access_token')} required className={classNames({ 'p-invalid': submitted && !client.powerbi_password })}  inputStyle={{width: '100%'}} />
                                        </div>
                                        <div className="p-field p-col-12 p-lg-12">
                                        Para obter essas informações:
                                        <ol>
                                            <li>Acesse <a href="https://www.mercadopago.com.br/developers">https://www.mercadopago.com.br/developers</a> e se autentique com suas credenciais.</li>
                                            <li>No menu do canto superior direito, onde diz "Olá [seu nome]", escolha a opção "Suas integrações".</li>
                                            <li>Na seção "Seus aplicativos", acesse o aplicativo desejado ou crie um novo.</li>
                                            <li>Na seção "Minhas credenciais" - "Credenciais", acesse "Credenciais de produção".</li>
                                        </ol>
                                        </div>
                                    </>
                                }
                            </Fieldset>
                        </div>
                    </Fieldset>

                    }
                    { ((client.modules || []).filter(m => m.id === "SUBSCRIPTION_PLANS").length > 0) &&
                    <Fieldset legend={"Mensagens do Fluxo de Assinatura"} toggleable style={{marginBottom: '5px'}}>
                            <div className="p-field p-col-12 p-lg-12">
                                <label htmlFor="description"><b>Feedback Assinatura</b></label>
                            </div>
                            <div className="p-field p-col-12 p-lg-12">
                                <InputTextarea disabled={saving} id="subscription_feedback" value={client.config.subscription_feedback} onChange={(e) => onInputChange(e, 'config.subscription_feedback')}  style={{width: '100%'}}/>
                            </div>
                            <div className="p-field p-col-12 p-lg-12">
                                <label htmlFor="description"><b>E-mail de Ativação</b></label>
                            </div>
                            <div className="p-field p-col-12 p-lg-12">
                                <label htmlFor="passwordSet_from">From*</label>
                            </div>
                            <div className="p-field p-col-12 p-lg-12">
                                <InputText disabled={saving} id="passwordSet_from" value={(client.email_config.subscritionActivated || {}).fromAddress} onChange={(e) => onInputChange(e, 'email_config.subscritionActivated.fromAddress')}  style={{width: '100%'}}/>
                            </div>
                            <div className="p-field p-col-12 p-lg-12">
                                <label htmlFor="passwordSet_subject">Subject*</label>
                            </div>
                            <div className="p-field p-col-12 p-lg-12">
                                <InputText disabled={saving} id="passwordSet_subject" value={(client.email_config.subscritionActivated || {}).subject} onChange={(e) => onInputChange(e, 'email_config.subscritionActivated.subject')}  style={{width: '100%'}}/>
                            </div>
                            <div className="p-field p-col-12 p-lg-12">
                                <label htmlFor="passwordSet_html">HTML*</label>
                            </div>
                            <div className="p-field p-col-12 p-lg-12">
                                <InputTextarea disabled={saving} id="passwordSet_html" value={(client.email_config.subscritionActivated || {}).html} onChange={(e) => onInputChange(e, 'email_config.subscritionActivated.html')}  style={{width: '100%'}}/>
                            </div>
                    </Fieldset>

                    }
                    <Fieldset legend={"Configuração do Google Analytics"} toggleable style={{marginBottom: '5px'}}>
                            <div className="p-field p-col-12 p-lg-12">
                                <label htmlFor="tracking_id"><b>Tracking ID</b> (formato: UA-XXXXXXXXX-1)</label>
                            </div>
                            <div className="p-field p-col-12 p-lg-12">
                                <InputText disabled={saving} id="tracking_id" value={client.config.googleAnalyticsTrackingId} onChange={(e) => onInputChange(e, 'config.googleAnalyticsTrackingId')}  style={{width: '100%'}}/>
                            </div>
                            <div className="p-field p-col-12 p-lg-12">
                            Para obter mais informações sobre como obter o Tracking ID, consulte a seção "Preparation" <a href="https://medium.com/geekculture/how-to-use-google-analytics-on-reactjs-in-5-minutes-7f6b43017ba9" target="_new">deste artigo</a>.
                            </div>
                    </Fieldset>
                </>}
                </div>

            </div>
        );
    }
    else {
        return (
            <div className="datatable-crud-demo">
                <div className="card">
                    <b>Permission Denied</b>
                </div>
            </div>
        );
    }
}